import React, { useState, useEffect } from 'react';

import Select from 'react-select';
import api from '../../services/api';

//alerta
import Notification from '../../components/Notification/Notification';

/* Material UI */
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import AccountCircle from '@mui/icons-material/AccountCircle';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import UpdateIcon from '@mui/icons-material/Update';
import Button from '@mui/material/Button';
import { makeStyles } from '@material-ui/core/styles';

import InputMask from "react-input-mask";

import './styles.css';

const useStyles = makeStyles((theme) => ({
  /* Estilização do conteúdo dentro do container */
  paper: {
    padding: theme.spacing(2),
    display: 'inline-block',
    flexDirection: 'row',
    minWidth: 'calc(100%)',
    [theme.breakpoints.up("sm")]: {
      minWidth: 500
    },
    marginRigth: '20px',
    marginTop: '40px',
    width: '100%',
    overflow: 'inherit',
    backgroundColor: '#cecece',
    boxShadow: 'none'
  },

  root: {
    width: '100%'
  },

  /* Estilização do títutlo */
  textTitle: {
    color: '#41414d',
    fontWeight: 600,
  },

  textDescription: {
    margin: theme.spacing(1),
    color: 'rgba(0, 0, 0, 0.54)',
  },

  labelInput: {
    fontFamily: 'Rawline',
    color: '#333333',
    fontWeight: 'bold',
    paddingLeft: 2,
    fontSize: 14
  }
}));

const styleMultiSelect = {
  control: (base) => ({
    ...base,
    position: 'relative',
    minHeight: 56,
    width: '100%',
    minWidth: 3,
    marginTop: 2,
  })
};

const classesStyles = {
  textField: {
    width: '100%',
    backgroundColor: '#fff',
    marginTop: 2,
  },
  labelInput: {
    fontFamily: 'Rawline',
    color: '#333333',
    fontWeight: 'bold',
    paddingLeft: 2,
    fontSize: 14,
    marginTop: 10
  },
  textTitle: {
    margin: 8,
    color: '#103168',
    fontWeight: 600,
    marginBottom: 30,
  },
  message: {
    padding: 10,
    backgroundColor: '#FFFBE8',
    color: 'rgba(0,0,0,0.8)',
    borderRadius: 7,
    width: '100%'
  },
  buttonConfirm: {
    backgroundColor: '#1551B3',
    color: '#fff',
    borderRadius: 20,
    height: '45px',
    textTransform: 'capitalize',
    fontWeight: 'bold',
    fontSize: 15,
    marginTop: '17px',
    minWidth: '220px'
  },
}

export default function EditInfoUser({ userPermission }) {
  const classes = useStyles();

  /* Estados dos campos enviados pelo método PUT */
  const [id, setId] = useState("");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [telefone, setTelefone] = useState("");
  const [role, setRole] = useState([]);
  const [areasSelect, setAreasSelect] = useState([]);
  const [areas, setAreas] = useState([]);

  // const [users, setUsers] = useState("");

  const [editName, setEditName] = useState(true);
  const [editTelefone, setEditTelefone] = useState(true);

  //alerta
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: '', title: '' })

  /* ************************************************************************ */
  /* Informações dos selects ************************************************ */
  // captura as áreas de atuação.
  // renomeia os campos do objeto para ser legível pelo componente multiselect.
  const areasAtuacao = areas.map(item => (
    { value: item.id, label: item.name }
  ));

  useEffect(() => {
    // id do usuário que será editado
    const id = window.location.pathname.split("/").pop();

    api.get(`${userPermission}/areas`).then(response => {
      setAreas(response.data);
    });

    api.get(`${userPermission}/users/${id}`).then(response => {
      setId(response.data.id);
      setName(response.data.name);
      setEmail(response.data.email);
      setTelefone(response.data.telefone);
      setPassword('');
      setRole(response.data.role);
      setAreasSelect(() => {
        if (role === "Executor") {
          return response.data.executor.map(item => ({ value: item.id, label: item.name }));
        } else if (role === "Controlador") {
          return response.data.manager.map(item => ({ value: item.id, label: item.name }));
        } else if (role === "Cidadão") {
          return "";
        }
      });
    });
  }, [role, userPermission]);

  function clearForm() {
    setId('');
    setName('');
    setEmail('');
    setTelefone('');
    setAreasSelect([]);
    setRole([]);
  }

  async function handleUpdate(e) {
    e.preventDefault();

    /* * O objeto data será enviado pela api para o endpoint /users. 
       * Destaca-se a necessidade de renomear o objeto areasSelect, para que o mesmo
         tenha os mesmo campos permitidos no campo manager ou executor da api 
         (value => id | label => name). */
    let data = {};

    /* Muda o objeto caso seja selecionado que o usuário é Controlador ou Executor */
    switch (role) {
      case "Controlador":
        data = {
          id,
          name,
          email,
          password,
          telefone,
          role,
          manager: areasSelect.map(item => ({
            id: item.value,
            name: item.label
          })
          )
        }
        break;

      case "Executor":
        data = {
          name,
          id,
          email,
          password,
          telefone,
          role,
          executor: areasSelect.map(item => ({
            id: item.value,
            name: item.label
          })
          )
        }
        break;

      default:
        data = {
          id,
          name,
          email,
          password,
          telefone,
          role,
        }
        break;
    }
    try {
      await api.put(`${userPermission}/users/${data.id}`, data);

      setNotify({
        isOpen: true,
        message: 'Dados do usuário atualizado com sucesso.',
        type: 'success',
        title: 'Atualizado'
      });
      clearForm();

    } catch (err) {
      setNotify({
        isOpen: true,
        message: 'Ocorreu um erro ao registrar o usuário.',
        type: 'error',
        title: 'Erro',
      });
    }
  };

  return (
    <Paper className={classes.paper}>
      <div className={classes.root}>
        <Typography variant="h5" align="center" style={classesStyles.textTitle}>
          Editar Informações
        </Typography>

        <div style={classesStyles.message}>
          Abaixo é possível editar informações do usuário selecionado.
        </div>

        <form onSubmit={handleUpdate} className="form-register">
          <Typography style={classesStyles.labelInput}>
            Nome completo: *
          </Typography>

          <TextField placeholder="Digite o nome do usuário"
            disabled={false}
            style={classesStyles.textField}
            variant="outlined"
            margin="normal"
            required
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <AccountCircle />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setEditName(editName === true ? false : true)}>
                    <EditIcon />
                  </IconButton>
                </InputAdornment>
              ),
              disabled: editName,
            }}
            value={name}
            onChange={e => setName(e.target.value)}
          />

          <Typography style={classesStyles.labelInput}>
            Telefone: *
          </Typography>

          <InputMask
            mask="(99) 9 9999-9999"
            maskChar=" "
            type="tel"
            value={telefone}
            onChange={e => setTelefone(e.target.value)}
          >
            {() => <TextField placeholder="Digite o telefone de usuário"
              style={classesStyles.textField}
              variant="outlined"
              margin="normal"
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <LocalPhoneIcon />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setEditTelefone(editTelefone === true ? false : true)}>
                      <EditIcon />
                    </IconButton>
                  </InputAdornment>
                ),
                disabled: editTelefone,
              }}
            />}
          </InputMask>

          <Typography style={classesStyles.labelInput}>
            Categorias de atuação: *
          </Typography>
          <Select isMulti
            options={areasAtuacao}
            placeholder="Selecione uma ou mais categorias vinculadas ao usuário"
            styles={styleMultiSelect}
            value={areasSelect}
            onChange={e => setAreasSelect(e)}
          />

          <Notification
            notify={notify}
            setNotify={setNotify}
          />

          <div className="register-user">
            <Button
              variant="outlined"
              type='submit'
              startIcon={<UpdateIcon style={{ 'color': '#fff' }} />}
              style={classesStyles.buttonConfirm}
            >
              Atualizar Usuário
            </Button>
          </div>
        </form>
      </div>
    </Paper>
  );
};
